// Fetch the current user's tenant config from /tenant/config and store
// the result in Redux so the sidebar (and later, every screen) can read
// per-tenant features and locale at runtime instead of from build-time
// env vars.

import axios from 'axios';
import {
  TENANT_CONFIG_REQUEST,
  TENANT_CONFIG_SUCCESS,
  TENANT_CONFIG_FAIL,
  TENANT_CONFIG_RESET,
} from '../constants/tenantConfigConstants';
import { applyTenantVocabulary, resetTenantVocabulary } from '../../i18n';
import { applyBrandTokens, resetBrandTokens } from '../../utils/brandTokens';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchTenantConfig = () => async dispatch => {
  try {
    dispatch({ type: TENANT_CONFIG_REQUEST });
    // Backend uses cookie auth — withCredentials is the global default
    // for axios in this app (see userActions.js).
    const { data } = await axios.get(`${BASE_URL}/tenant/config`);
    // Response shape: { status: 'success', data: <projected tenantConfig> }
    const config = data?.data || null;
    // Tenant terminology is applied to i18next rather than stored in Redux
    // and read per screen: it becomes interpolation variables, so every
    // string that references {{claims}} picks it up with no screen changes.
    // Overrides only — the per-locale defaults live in the bundles.
    applyTenantVocabulary(config?.vocabularyOverrides);
    // Brand colours land as two CSS custom properties read by a short,
    // fixed list of surfaces (active nav, primary action). Same lifecycle
    // as vocabulary so a Settings save repaints without a reload.
    applyBrandTokens(config?.branding);
    dispatch({ type: TENANT_CONFIG_SUCCESS, payload: config });
  } catch (err) {
    dispatch({
      type:    TENANT_CONFIG_FAIL,
      payload: err.response?.data?.message || err.message,
    });
  }
};

export const resetTenantConfig = () => dispatch => {
  // Drop the tenant's words too, or the next user to log in on this browser
  // inherits the previous tenant's terminology until their config resolves.
  resetTenantVocabulary();
  resetBrandTokens();
  dispatch({ type: TENANT_CONFIG_RESET });
};
